import React, { useState } from 'react';
import Button from '../../../components/ui/button';
import Select from '../../../components/ui/select';
import Icon from '../../../components/appIcon';

const EmployeeActionBar = ({
  selectedEmployees,
  onAddEmployee,
  onBulkAction,
  totalEmployees,
  filteredEmployees
}) => {
  const [bulkActionType, setBulkActionType] = useState('');

  const bulkActionOptions = [
    { value: '', label: 'Bulk Actions' },
    { value: 'activate', label: 'Activate Selected' },
    { value: 'deactivate', label: 'Deactivate Selected' },
    // { value: 'suspend', label: 'Suspend Selected' },
    { value: 'export', label: 'Export Selected' },
    { value: 'delete', label: 'Delete Selected' }
  ];

  const handleBulkAction = () => {
    if (bulkActionType && selectedEmployees?.length > 0) {
      onBulkAction(bulkActionType, selectedEmployees);
      setBulkActionType('');
    }
  };

  const getBulkActionButtonVariant = () => {
    if (bulkActionType === 'delete') return 'destructive';
    if (bulkActionType === 'suspend') return 'warning';
    return 'outline';
  };

  return (
    <div className="">
      <div className="flex flex-col lg:flex-row items-end lg:items-end justify-end gap-4">
        {/* Left Section - Add Employee & Bulk Actions */}
        <div className="flex flex-col  sm:flex-row items-end sm:items-center gap-3">
          <Button
            onClick={onAddEmployee}
            iconName="Plus"
            iconPosition="left"
            className="whitespace-nowrap"
          >
            Add Employee
          </Button>

          {selectedEmployees?.length > 0 && (
            <div className="flex items-center gap-2">
              <Select
                options={bulkActionOptions}
                value={bulkActionType}
                onChange={setBulkActionType}
                placeholder="Select action"
                className="min-w-[160px]"
              />
              <Button
                variant={getBulkActionButtonVariant()}
                onClick={handleBulkAction}
                disabled={!bulkActionType}
                size="sm"
              >
                Apply
              </Button>
            </div>
          )}
        </div>

        {/* Center Section - Employee Count */}
        <div className="flex items-center space-x-4 text-sm text-muted-foreground">
          {selectedEmployees?.length > 0 && (
            <span className="flex items-center space-x-1">
              <Icon name="CheckSquare" size={16} />
              <span>{selectedEmployees?.length} selected</span>
            </span>
          )}
          {/* <span className="flex items-center space-x-1">
            <Icon name="Users" size={16} />
            <span>
              {filteredEmployees !== totalEmployees 
                ? `${filteredEmployees} of ${totalEmployees} employees`
                : `${totalEmployees} employees`
              }
            </span>
          </span> */}
        </div>

      </div>
      {/* Bulk Action Confirmation */}
      {selectedEmployees?.length > 0 && (
        <div className="mt-4 pt-4 border-t border-border">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2 text-sm">
              <Icon name="Info" size={16} className="text-primary" />
              <span className="text-muted-foreground">
                {selectedEmployees?.length} employee{selectedEmployees?.length !== 1 ? 's' : ''} selected
              </span>
            </div>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onBulkAction('clear-selection', [])}
              iconName="X"
              iconPosition="left"
            >
              Clear Selection
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default EmployeeActionBar;